import script from "./CobranzaView.vue?vue&type=script&setup=true&lang=js"
export * from "./CobranzaView.vue?vue&type=script&setup=true&lang=js"

import "./CobranzaView.vue?vue&type=style&index=0&id=641d43de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-641d43de"]])

export default __exports__